import { setCookie } from '../utils/cookies'
import { getCssVar, setCssVar } from '../utils/css'
import { getHostPrimaryDomain } from '../utils/location'

export default () => {
    const el = document.querySelector('.cookie-banner')

    const cookieBtnAccept = el?.querySelector('.cookie-banner-accept')

    const cookieBtnDeny = el?.querySelector('.cookie-banner-deny')

    if (!cookieBtnAccept
            && !cookieBtnDeny)
        return

    const setCookieBannerCssVar = () => {
        const content = el
            && el.querySelector('.cookie-banner-content')

        const bannerHeight = `${(content || {}).clientHeight || 0}px`

        if (bannerHeight !== getCssVar('--cookie-banner-height'))
            setCssVar('--cookie-banner-height', bannerHeight)
    }

    setCookieBannerCssVar()

    el.id = el.id || `cookie-banner-${(new Date()).getTime()}`

    const setAllowCookieBanner = (value) => {
        setCookie(el.id, value, {
            expires: 365,
            domain: `.${getHostPrimaryDomain()}`,
            sameSite: 'none'
        })

        if (window.gtag)
            window.gtag('consent', 'update', {
                analytics_storage: value
            })

        el.parentElement
            .removeChild(el)

        setCookieBannerCssVar()
    }

    cookieBtnAccept
        .addEventListener('click', () => {
            setAllowCookieBanner('granted')
        })

    cookieBtnDeny
        .addEventListener('click', () => {
            setAllowCookieBanner('denied')
        })

    window.addEventListener('resize', setCookieBannerCssVar)

    return el
}
